import React, { useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import AuthInput from "../../Components/AuthInput";
import useResetPassword from "./useResetPassword";
import AuthScreenLayout from "../../Components/Auth/AuthScreenLayout";
import AuthBrandMark from "../../Components/Auth/AuthBrandMark";
import { useReduxStore } from "../../hooks/useReduxStore";
import { authPrimaryButtonClass as primaryBtn } from "../../Components/Auth/authClasses";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { getState } = useReduxStore();
  const { settings } = getState("AUTH") || {};
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const { register, handleSubmit, onSubmit, errors, passwordReset, loading } = useResetPassword({ token, email });

  useEffect(() => {
    if (!token || !email) {
      navigate("/forgot-password");
    }
  }, [token, email, navigate]);

  return (
    <AuthScreenLayout cardMaxWidthClass="max-w-2xl">
      <AuthBrandMark settings={settings} />

      {passwordReset ? (
        <div className="space-y-6 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-500/20 ring-1 ring-emerald-400/40">
            <svg className="h-8 w-8 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-white sm:text-xl">Password reset successful</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/70">
              Your password has been reset. You can now sign in with your new password.
            </p>
          </div>
          <Link to="/Login" className={`${primaryBtn} inline-block`}>
            Go to Sign in
          </Link>
        </div>
      ) : (
        <>
          <div className="mb-8 text-center">
            <h1 className="text-xl font-semibold tracking-tight text-white sm:text-2xl">Reset your password</h1>
            <p className="mt-2 text-sm leading-relaxed text-white/65">Enter your new password below.</p>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <AuthInput
              label="Email"
              type="email"
              name="email"
              id="email"
              placeholder="Enter Your Email"
              errors={errors}
              register={register}
              disabled={true}
              variant="glass"
            />
            <AuthInput
              label="New Password"
              type="password"
              name="newPassword"
              id="newPassword"
              placeholder="Enter new password"
              errors={errors}
              register={register}
              variant="glass"
            />
            <AuthInput
              label="Confirm New Password"
              type="password"
              name="confirmPassword"
              id="confirmPassword"
              placeholder="Confirm new password"
              errors={errors}
              register={register}
              variant="glass"
            />

            <div className="pt-1">
              <button type="submit" disabled={loading} className={primaryBtn}>
                {loading ? "Resetting…" : "Reset Password"}
              </button>
            </div>
          </form>

          <p className="mt-8 text-center text-sm text-white/75">
            <Link
              to="/Login"
              className="transition hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue"
            >
              Back to Sign in
            </Link>
          </p>
        </>
      )}
    </AuthScreenLayout>
  );
}
